module.exports = __webpack_public_path__ + "static/isaveon-7b66f1b42555f762ca4ee6d33466b297.jpg";